<template>
    <div>
        <ul class="noticeInfo" ref="req_form">
            <!--<li>-->
                <!--<div class="product">-->
                    <!--<label >Product</label>-->
                    <!--<select name="" id="">-->
                        <!--<option value="Alpha Base Station">Alpha Base Station</option>-->
                        <!--<option value="Alpha 11x11mm Chipset">Alpha 11x11mm Chipset</option>-->
                    <!--</select>-->
                    <!--<div class="warn">-->
                        <!--<span class="form-warning-message product-error">Please select product</span>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</li>-->
            <li>
                <div class="fullName">
                    <label>Name</label>
                    <input type="text" v-model="requestData.name" name="name" @input="change">
                   <div class="warn">
                       <span class="form-warning-message name-error">Please fill in recipient's name</span>
                   </div>
                </div>
                <div class="phoneNumber">
                    <label>Phone Number</label>
                    <input type="text" v-model="requestData.mobile" placeholder="" name="mobile" @input="change">
                    <div class="warn">
                        <span class="form-warning-message mobile-error">Please fill in the correct phone number</span>
                    </div>
                </div>
            </li>
            <li>
                <div class="emailAdress">
                    <label>Email Address</label>
                    <input type="text" v-model="requestData.email" name="email" @input="change">
                    <div class="warn">
                        <span class="form-warning-message email-error">Please fill in the correct email address</span>
                    </div>
                </div>
                <div class="country">
                    <label>Country</label>
                    <input type="text" v-model="requestData.country" name="country" @input="change">
                    <div class="warn">
                        <span class="form-warning-message country-error">Please fill in the correct country and regions</span>
                    </div>
                </div>
            </li>
            <li>
                <div class="companyName">
                    <label>Company Name</label>
                    <input type="text" v-model="requestData.company" name="company" @input="change">
                    <div class="warn">
                        <span class="form-warning-message company-error">Please fill in the correct company name</span>
                    </div>
                </div>
            </li>
            <li>
                <div class="advisoy">
                    <label>Descriptions</label>
                    <textarea type="text" @input="change" v-model="requestData.advisory" ></textarea>

                </div>
            </li>
            <li>
                 <a href="javascript: void(0)" @click="create"><button :disabled="formIsTrading">SEND</button></a>
            </li>

        </ul>
    </div>
</template>

<script>
    import { Message } from 'element-ui';
    import 'element-ui/lib/theme-chalk/message.css'
    import 'element-ui/lib/theme-chalk/icon.css'
    export default {
        name: "request",
        props: ["submit", "item"],
        data () {
            return {
                requestData: {
                    name: '',
                    mobile: '',
                    email: '',
                    company: '',
                    country: '',
                    advisory: ''
                },
                // 订单正在处理中
                formIsTrading: true
            }
        },
        methods: {
            // 清空表单
            clean () {
                let keys = ['name', 'mobile', 'email', 'company', 'country', 'advisory']
                keys.forEach(key => {
                    this.requestData[key] = ''
                })
            },
            create() {
                let data = Object.assign({}, this.requestData)
                if (this.item) {
                    data.advisory = `<<${this.item.name}>> ${data.advisory}`
                }
                return this.$http.post(`${this.config.IOT_API_URL}/anonymous/contact`, data).then(ret => {
                    Message({
                        showClose: true,
                        message: 'Send message success',
                        type: 'success'
                    })
                    this.clean()
                    if (this.submit) {
                        this.submit(ret);
                    }
                    return ret;
                }).catch(err => {
                    Message({
                        showClose: true,
                        message: 'Send message failed',
                        type: 'error'
                    })
                })
            },
            // 错误提示显示
            toggleErrorTooltip (key, hide) {
                let el = this.$refs.req_form.querySelector(`.${key}-error`)
                if (!el) return;
                if (hide) {
                    el.style.display = 'none'
                } else {
                    el.style.display = 'block'
                    this.formIsTrading = true;
                }
            },

            // 订单数据验证
            orderDataValidator (data, field) {
                let required = ['name', 'mobile', 'email', 'company', 'country', 'advisory']
                let error = false;
                required.forEach(key => {
                    if (!data[key]) {
                        if (field && key === field) {
                            this.toggleErrorTooltip(key)
                        } else if (!field) {
                            this.toggleErrorTooltip(key)
                        }
                        error = true;
                    } else {
                        this.toggleErrorTooltip(key, true)
                    }
                })

                if (!error) {
                    this.formIsTrading = false;
                }
                return error;
            },
            // 监听用户信息表单变化
            change(e) {
                this.orderDataValidator(this.requestData, e.target.name)
            },
        }
    }
</script>

<style lang="less">
    .noticeInfo {

        li {
            width: 800px;
            margin: 0 auto 24px;
            /*height: 72px;*/
            display: flex;
            justify-content: space-between;
            input {
                width: 100%;
                height: 32px;
                background: #fafafa;
                border: none;
                outline: none;
                padding: 12px;
                font-size: 14px;
                color: #252525;
                line-height: 22px;
            }
            .companyName,.advisoy{
                width: 800px;
            }
            label{
                display: block;
                width: 100%;
                padding-left: 10px;
                padding-top: 10px;
                background: #fafafa;
                font-size: 14px;
                color: #B6B6B6;
                line-height: 22px;
            }
            select {
                position: relative;
                width: 100%;
                border: none;
                outline: none;
                padding: 12px;
                font-size: 14px;
                color: #252525;
                line-height: 22px;
                height: 48px;
                option {
                    position: absolute;
                    top: 0;
                    left: 0;

                }
            }
            textarea {
                  width: 100%;
                  height: 138px;
                  resize: none;
                  background: #fafafa;
                  padding: 8px;
                  border: none;
                  outline: none;
              }
            .warn {
                height: 14px;
            }
            .fullName,.phoneNumber,.emailAdress,.country{
                width: 380px;
                input{
                    width: 100%;
                }
                label{
                    display: block;
                    width: 380px;
                }

            }
            /*&:nth-child(5){*/
                /*height: 174px;*/
            /*}*/
            /*&:nth-child(5) input{*/
                /*height: 174px;*/
            /*}*/
            &:last-child a {
                margin: 0 auto;
            }
            &:last-child button {
                width: 180px;
                height: 58px;
                font-size: 14px;
                color: #252525;
                line-height: 22px;
                outline: none;
                border: 1px solid #252525;
                text-align: center;
            }
            a{
                text-decoration: none;
                font-weight: bold;
                color: #348FFA;
            }
            .form-warning-message {
                display: none;
                width: 100%;
                height: 100%;
                font-size: 14px;
                line-height: 22px;
                color: red;
            }
        }
    }
    @media screen and (max-width: 1680px){
        .noticeInfo {
            li {
                input {

                }
                label{

                }
                textarea {
                    height: 64px;

                }
                .fullName,.phoneNumber,.emailAdress,.country{
                    width: 380px;
                    input{
                        width: 100%;
                    }
                    label{
                        display: block;
                        width: 380px;
                    }
                }
                &:nth-child(5){
                    height: 64px;
                }

                &:last-child button {

                    /*margin-top: 20px;*/
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/common/Request.vue